import React, { useEffect, useRef, useState } from "react";

import "./GPMS_Challenge.css";

const iconProps = {
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "currentColor",
  strokeWidth: 1.7,
  strokeLinecap: "round",
  strokeLinejoin: "round",
};
 
const icons = {
  database: (
    <svg {...iconProps}>
      <ellipse cx="12" cy="5" rx="8" ry="3" />
      <path d="M4 5v6c0 1.7 3.6 3 8 3s8-1.3 8-3V5" />
      <path d="M4 11v6c0 1.7 3.6 3 8 3s8-1.3 8-3v-6" />
    </svg>
  ),
  truck: (
    <svg {...iconProps}>
      <path d="M2 6h11v10H2z" />
      <path d="M13 9h4l4 4v3h-8z" />
      <circle cx="7" cy="18" r="2" />
      <circle cx="17" cy="18" r="2" />
    </svg>
  ),
  container: (
    <svg {...iconProps}>
      <rect x="3" y="6" width="18" height="12" rx="1" />
      <path d="M7 6v12M11 6v12M15 6v12M19 6v12" />
    </svg>
  ),
  chart: (
    <svg {...iconProps}>
      <path d="M3 3v18h18" />
      <path d="M7 15l4-4 3 3 5-6" />
      <path d="M16 8h3v3" />
    </svg>
  ),
  scan: (
    <svg {...iconProps}>
      <path d="M4 8V5a1 1 0 011-1h3M16 4h3a1 1 0 011 1v3M20 16v3a1 1 0 01-1 1h-3M8 20H5a1 1 0 01-1-1v-3" />
      <path d="M8 9h8M8 12h8M8 15h5" />
    </svg>
  ),
  clock: (
    <svg {...iconProps}>
      <circle cx="12" cy="12" r="9" />
      <path d="M12 7v5l3 2" />
    </svg>
  ),
  shield: (
    <svg {...iconProps}>
      <path d="M12 3l8 3v6c0 4.5-3.2 7.9-8 9-4.8-1.1-8-4.5-8-9V6z" />
      <path d="M8.5 12l2.5 2.5 4.5-5" />
    </svg>
  ),
};
 
const challenges = [
  {
    icon: icons.database,
    title: "Fragmented Operational Data",
    text: "Critical information is spread across Navis, CMS, gate management systems, and other applications, making it difficult to obtain a consolidated operational view.",
  },
  {
    icon: icons.truck,
    title: "Gate Congestion & Truck Delays",
    text: "Unpredictable truck arrivals, peak traffic periods, and processing delays contribute to long waiting times and inefficient gate utilization.",
  },
  {
    icon: icons.container,
    title: "Excessive Container Dwell Time",
    text: "Containers remaining in terminals longer than expected occupy valuable yard space, increase congestion, and affect operational efficiency.",
  },
  {
    icon: icons.chart,
    title: "Limited Predictive Capabilities",
    text: "Traditional reporting identifies problems after they occur, providing limited opportunities for early intervention.",
  },
  {
    icon: icons.scan,
    title: "Manual Vehicle & Container Identification",
    text: "Manual identification and verification of vehicle registration numbers and container IDs can introduce errors and increase processing time.",
  },
  {
    icon: icons.clock,
    title: "Delayed Operational Decision-Making",
    text: "Without centralized, timely information, identifying operational bottlenecks and making effective decisions becomes challenging.",
  },
];

function GPMS_Challenge() {
  
    // <div className="container-fluid">
    //   <div className="row position-relative gpms-chall-row">

    //     <div className="col-12 col-md-6 gpms-chall-bg1">
    //       <div className="p-4">
    //         <h1 className="text-light fs-12 gpms-chall-title">Why Modern Port Operations Struggle</h1>
    //       </div>
    //     </div>

    //     <div className="col-12 col-md-6 gpms-chall-bg2">
    //       <div>
    //         <p className="text-dark fw-bold gpms-chall-desc">
    //           Most ports today operate on disconnected systems, leading to delays, inefficiencies, and poor visibility across operations.
    //         </p>
    //       </div>
    //     </div>

    //     <div className="gpms-chall-slider-overlay">
    //       <div className="gpms-chall-slider">
    //         <div className="gpms-chall-slide-track">

    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall1.png" alt="Manual errors in vehicle classification" />
    //             <h5>No real-time operational visibility</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall2.webp" alt="Fraudulent exemptions and misuse" />
    //             <h5>Gate congestion & high truck turnaround time</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall3.jpeg" alt="Lack of real-time monitoring" />
    //             <h5>Manual errors in data capture</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall4.jpg" alt="Inaccurate FASTag transactions" />
    //             <h5>Increasing container dwell time</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall5.jpg" alt="No centralized control across toll plazas" />
    //             <h5>Delayed response to operational risks</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall6.jpg" alt="Limited visibility into operations" />
    //             <h5>Disconnected reporting across departments</h5>
    //           </div>

    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall1.png" alt="No real-time operational visibility" />
    //             <h5>No real-time operational visibility</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall2.webp" alt="Fraudulent exemptions and misuse" />
    //             <h5>Gate congestion & high truck turnaround time</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall3.jpeg" alt="Manual errors in data capture" />
    //             <h5>Manual errors in data capture</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall4.jpg" alt="Increasing container dwell time" />
    //             <h5>Increasing container dwell time</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall5.jpg" alt="Delayed response to operational risks" />
    //             <h5>Delayed response to operational risks</h5>
    //           </div>
    //           <div className="gpms-chall-slide">
    //             <img src="/ImagesNew/gpms_chall6.jpg" alt="Disconnected reporting across departments" />
    //             <h5>Disconnected reporting across departments</h5>
    //           </div>

    //         </div>
    //       </div>
    //     </div>

    //   </div>
    // </div>
      const bodyRef = useRef(null);
  const [visible, setVisible] = useState(false);
 
  // reveal cards when the section scrolls into view
  useEffect(() => {
    const el = bodyRef.current;
    if (!el || typeof IntersectionObserver === "undefined") {
      setVisible(true);
      return;
    }
    const io = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setVisible(true);
          io.disconnect();
        }
      },
      { threshold: 0.15 }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);
 
  return (
    <section className="gc-section">
      {/* ---------- Split header ---------- */}
      <div className="gc-header">
        <div className="gc-container">
          <div className="gc-top">
            <div>
              <span className="gc-eyebrow">
                <i /> Industry Challenges
              </span>
              <h2 className="gc-title">
                The Challenges Facing <span>Modern Ports</span>
              </h2>
              <p className="gc-tagline">
                <b>Complex Operations.</b>
                <b>Disconnected Systems.</b>
                <b>Limited Visibility.</b>
              </p>
            </div>
 
            <div className="gc-intro">
              <p>
                Modern ports manage thousands of container movements, truck
                transactions, vessel activities, and operational processes
                every day.
              </p>
              <p>
                Although these activities generate large amounts of valuable
                information, the data often remains distributed across multiple
                independent systems.
              </p>
              <p>
                This creates significant challenges for port authorities,
                terminal operators, and management teams.
              </p>
            </div>
          </div>
        </div>
      </div>
 
      {/* ---------- Cards ---------- */}
      <div className={`gc-body ${visible ? "gc-visible" : ""}`} ref={bodyRef}>
        <div className="gc-container">
          <div className="gc-grid">
            {challenges.map((item, i) => (
              <article
                className="gc-card"
                key={item.title}
                style={{ "--delay": `${i * 0.1}s` }}
              >
                <span className="gc-num">{String(i + 1).padStart(2, "0")}</span>
                <div className="gc-icon">{item.icon}</div>
                <h3>{item.title}</h3>
                <p>{item.text}</p>
                <span className="gc-line" />
              </article>
            ))}
          </div>
 
          <div className="gc-footer">
            <span className="gc-footer-icon">{icons.shield}</span>
            <span>
              GPMS addresses these challenges by bringing operational
              analytics, computer vision, and predictive intelligence together
              in one integrated platform.
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}

export default GPMS_Challenge;